/**
 * Guest Phone component
 * react-phone-number
 */

import React from 'react';
import PropTypes from 'prop-types'
import * as FPT from '../utility/fpt'
import PhoneNumber from 'react-phone-number';
import PhoneType from '../components/phone-type';

const PhoneComponent = React.createClass({

	propTypes: {
		handlePhoneInfo: PropTypes.func.isRequired,
		initialData: PropTypes.object,
		errorMessages: PropTypes.object,
		phoneNumberCountryCode: PropTypes.string,
		selectedCountry: PropTypes.string,
		isRequired: PropTypes.bool,
		examplePhoneNumber: PropTypes.string,
		guestLabels: PropTypes.object,
		onRef: PropTypes.func,
	},

	getInitialState () {

		const { phoneNumberCountryCode, phoneNumberPatternDesc = {}, senderDetails = {} } = this.props.initialData || {}
		const { maxLength = 10 } = phoneNumberPatternDesc.NATIONAL || {}
		const { phone_number = '' } = senderDetails.phone || {}

		return {
			phoneNumberCountryCode: phoneNumberCountryCode,
			maxlength: parseInt(maxLength, 10) + 1, // react-phone-number is appending 0 to all number
			errMessagePhoneNumber: '',
			errMessagePhoneType: '',
			phone: phone_number
		};
	},

	componentDidMount() {
		this.props.onRef(this)
	},

	componentWillUnmount() {
		this.props.onRef(undefined)
	},

	/*
	* Handle focus on input
	*/
	handleFocus(key) {
		let ele = {}
		ele[key] = ''
		this.setState(ele)
	},

	/*
	* Handle phone number blur
	*/
	handlePhoneBlur(phone) {
		if (!phone) {
			const { REQUIRED_PHONE_NUMBER = '' } = this.props.errorMessages
			this.setState({ errMessagePhoneNumber: REQUIRED_PHONE_NUMBER })
			FPT.trackError({ message: REQUIRED_PHONE_NUMBER, fieldId: 'phonenumber', code: 'REQUIRED_PHONE_NUMBER' });
		}
	},

	/*
	* Handle phone number change
	*/
	handlePhoneNumber(phoneNumber) {
		this.setState({ phoneNumber: phoneNumber });
		this.handlePhoneInfo(this.state.phoneType, phoneNumber);
	},

	/*
	* Handle phone type change
	*/
	handlePhoneType(phoneType) {
		this.setState({ phoneType: phoneType, errMessagePhoneType: '' })
		this.handlePhoneInfo(phoneType, this.state.phoneNumber)
	},

	/*
	* Handle phone information
	*/
	handlePhoneInfo(type = 'Mobile', number) {
		const { phoneNumberCountryCode } = this.props;
		this.props.handlePhoneInfo({ type: type, number: number, countryCode: phoneNumberCountryCode })
	},

	/*
	* Handling required payment form fields
	*/
	handleRequiredFields(params) {
		const { errorMessages } = this.props
		let isValid = true
		let errMessagePhoneType, errMessagePhoneNumber
		let keysToValidate = Object.keys(params)

		keysToValidate.forEach((key) => {
			let value = params[key]

			switch (key) {
				case 'number':
					if (!value) {
						isValid = false;
						errMessagePhoneNumber = errorMessages.REQUIRED_PHONE_NUMBER;
						FPT.trackError({ message: errMessagePhoneNumber, fieldId: 'phonenumber', code: 'REQUIRED_PHONE_NUMBER' });
					}
					break;
				default:
					break;
			}
		});

		if (!isValid) {
			this.setState({
				errMessagePhoneType: errMessagePhoneType,
				errMessagePhoneNumber: errMessagePhoneNumber,
			})
		}
		return isValid
	},

	/*
	* Handle phone number error
	*/
	handlePhoneError(key) {
		const { errorMessages } = this.props
		let errMessagePhoneNumber = errorMessages[key]
		this.setState({ errMessagePhoneNumber: errMessagePhoneNumber });
		FPT.trackError({ message: errMessagePhoneNumber, fieldId: 'phonenumber', code: key });
	},

	render() {
		const { guestLabels: { phone: phoneLabel, phoneType: phoneTypeLabel = '' } = {}, defaultNumber = {} } = this.props || {};

		return (
			<div className="row">
				<div className="col-md-4 col-sm-4 col-xs-4">
					<PhoneType
						{...this.props}
						label={phoneTypeLabel}
						errorMessage={this.state.errMessagePhoneType}
						changePhoneType={this.handlePhoneType}/>
				</div>
				<div className="col-md-8 col-sm-8 col-xs-8 phone_holder">
					<PhoneNumber
						label={phoneLabel}
						value={defaultNumber.number}
						errorMessage={this.state.errMessagePhoneNumber}
						country={this.props.selectedCountry}
						maxlength={this.state.maxlength}
						showIsRequiredError={this.props.isRequired}
						exampleNumber={this.props.examplePhoneNumber}
						handleFocus={() => this.handleFocus('errMessagePhoneNumber')}
						handleBlur={this.handlePhoneBlur}
						changePhone={this.handlePhoneNumber}/>
				</div>
			</div>
		)
	}
})

export default PhoneComponent;



// WEBPACK FOOTER //
// ./containers/phone-component.js